import SingleSelectCards from './SingleSelectCards';

/**
 * QuickScanStep1Goal — "Waar wilt u vooral op besparen?"
 * Soft entry question. No technical jargon. Single-select required.
 */
export default function QuickScanStep1Goal({ value, onUpdate, error }) {
  return (
    <div data-testid="qs-step-1" className="space-y-5">
      <div>
        <h2
          className="text-2xl sm:text-3xl font-medium text-white leading-tight"
          style={{ fontFamily: 'Outfit' }}
          data-testid="qs-step-1-headline"
        >
          Waar wilt u vooral op besparen?
        </h2>
        <p className="text-sm text-white/65 mt-1.5" data-testid="quickscan-step1-intro">
          Eén tik — daarna direct door naar vraag 2.
        </p>
      </div>

      <SingleSelectCards
        label=""
        value={value}
        options={[
          { value: 'use_own_solar', label: 'Eigen zonnestroom beter gebruiken' },
          { value: 'lower_bill', label: 'Lagere energierekening' },
          { value: 'peak_management', label: 'Slimmer omgaan met piekverbruik' },
          { value: 'salderen_2027', label: 'Voorbereiden op afbouw salderen (2027)' },
          { value: 'unknown', label: 'Ik weet het nog niet' },
        ]}
        onChange={onUpdate}
        testIdPrefix="qs-goal"
        error={error}
        columns={1}
      />
    </div>
  );
}
